import {
    CREATE_ADDRESS_FAIL,
    CREATE_ADDRESS_REQUEST,
    CREATE_ADDRESS_SUCCESS,
    LOAD_ADDRESSES_FAIL,
    LOAD_ADDRESSES_REQUEST,
    LOAD_ADDRESSES_SUCCESS,
    ADDRESS_DETAILS_FAIL,
    ADDRESS_DETAILS_REQUEST,
    ADDRESS_DETAILS_SUCCESS,
    UPDATE_ADDRESS_FAIL,
    UPDATE_ADDRESS_REQUEST,
    UPDATE_ADDRESS_SUCCESS,
    DELETE_ADDRESS_FAIL,
    DELETE_ADDRESS_REQUEST,
    DELETE_ADDRESS_SUCCESS,
    CLEAR_ERRORS
} from "../constants/addressConstant"

const initialState = {
    addresses: [],
    loading: false,
}

export const addressReducer = (state = initialState, action) => {

    switch (action.type) {

        case CREATE_ADDRESS_REQUEST:
        case DELETE_ADDRESS_REQUEST:
        case LOAD_ADDRESSES_REQUEST:
            
            return {
                ...state,
                loading: true,
            }
        
        case LOAD_ADDRESSES_SUCCESS:
        
            return {
                ...state,
                loading:false,
                addresses: action.payload.addresses,
            }

        case CREATE_ADDRESS_FAIL:
        case LOAD_ADDRESSES_FAIL:
        case DELETE_ADDRESS_FAIL:
    
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        
        case CREATE_ADDRESS_SUCCESS:
    
            return {
                ...state,
                loading:false,
                addresses: [...state.addresses, action.payload],
            }

        case DELETE_ADDRESS_SUCCESS:

            return {
                ...state,
                loading:false,
                addresses: state.addresses.filter((i)=>i._id !== action.payload.id),
            }

        case CLEAR_ERRORS:
    
            return {
                ...state,
                error: null
            }
    
        default:
            return state
    }

}
